import React from 'react'
import AppLayout from 'components/layout/layout'
import './styles/main-page.scss'
import { Tabs } from 'antd'
import Website from './components/website'
import BreadCrumbs from 'components/global/BreadCrumbs'
import { Key } from '@phosphor-icons/react'
import Partners from './components/partners/Partners'

const ManageWebsite: React.FC = () => {
  const items = [
    {
      key: 'content',
      label: 'Content',
      children: <Website />,
    },
    {
      key: 'partners',
      label: 'Partners',
      children: <Partners />,
    },
  ]

  const tabChange = (key: string) => {}

  return (
    <AppLayout>
      <div className="main-container">
        <div className="mb-40">
          <BreadCrumbs
            links={[
              {
                name: 'Settings',
                link: '/settings?tab=GeneralSetting',
              },
              {
                name: 'Website Content',
                link: '/settings/website-content-managment',
              },
            ]}
          />
        </div>
        <div className="main-content-container">
          <Tabs
            defaultActiveKey="content"
            items={items}
            className="website-tab w-full"
            onChange={tabChange}
          />
        </div>
      </div>
    </AppLayout>
  )
}

export default ManageWebsite
